import { Post } from 'interfaces/post';
import parser from 'html-react-parser';
import { parseDate } from 'utils/blogHelpers';

interface Props {
  post: { attributes: Post };
  version: number;
  withImage?: boolean;
}

const BlogCard: React.FC<Props> = ({ post, version, withImage = true }) => {
  const { attributes } = post;

  if (version === 2) {
    return (
      <div className="flex flex-wrap py-8">
        <div className="flex flex-col flex-shrink-0 mb-6 md:w-64 md:mb-0">
          <span className="font-medium tracking-widest text-gray-900 title-font">
            {attributes.category}
          </span>
          <span className="mt-1 text-sm text-gray-500">
            {attributes.date &&
              parseDate(attributes.date).toISOString().split('T')[0]}
          </span>
        </div>
        <div className="md:flex-grow">
          <h2 className="mb-2 text-2xl font-medium text-gray-900 title-font">
            {attributes.title}
          </h2>
          <p className="leading-relaxed">{attributes.description}</p>

          <a
            className="inline-flex items-center mt-4 text-san-juan-blue-500"
            href={`/blog/${attributes.slug}`}
          >
            Learn More
            <svg
              className="w-4 h-4 ml-2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </div>
    );
  }

  if (version === 3) {
    return (
      <div className="flex flex-wrap py-8 md:flex-no-wrap">
        <div className="relative h-full px-8 pt-16 pb-24 overflow-hidden text-center bg-gray-200 rounded-lg">
          <h2 className="mb-1 text-xs font-medium tracking-widest text-gray-500 title-font">
            {attributes.category}
          </h2>
          <h1 className="mb-3 text-xl font-medium text-gray-900 title-font sm:text-2xl">
            {attributes.title}
          </h1>
          <p className="mb-3 leading-relaxed">{attributes.description}</p>
          <a
            className="inline-flex items-center text-san-juan-blue-500"
            href={`/blog/${attributes.slug}`}
          >
            Learn More
            <svg
              className="w-4 h-4 ml-2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full overflow-hidden border border-gray-200 rounded-lg">
      {withImage && (
        <img
          className="object-cover object-center w-full lg:h-48 md:h-36"
          src={attributes.image}
          alt="blog"
          loading="lazy"
        />
      )}
      <div className="p-6">
        <h2 className="mb-1 text-xs font-medium tracking-widest text-gray-500 title-font">
          {attributes.category}
          <span className="mb-1 text-sm text-gray-500 float-right h-4">
            {attributes.date &&
              parseDate(attributes.date).toISOString().split('T')[0]}
          </span>
        </h2>
        <h1 className="mb-3 text-lg font-medium text-san-juan-blue-500 title-font">
          <a
            className="font-medium md:mb-2 lg:mb-0"
            href={`/blog/${attributes.slug}`}
          >
            {parser(attributes.title)}
          </a>
        </h1>
        <p className="mb-3 leading-relaxed">{attributes.description}</p>
        <div className="flex flex-wrap items-center ">
          <a
            className="inline-flex items-center font-medium text-san-juan-blue-500 md:mb-2 lg:mb-0"
            href={`/blog/${attributes.slug}`}
          >
            Read more
            <svg
              className="w-4 h-4 ml-2"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 12h14"></path>
              <path d="M12 5l7 7-7 7"></path>
            </svg>
          </a>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
